import { render, staticRenderFns } from "./TicketPosFutbol.vue?vue&type=template&id=5378ab36&scoped=true&"
import script from "./TicketPosFutbol.vue?vue&type=script&lang=js&"
export * from "./TicketPosFutbol.vue?vue&type=script&lang=js&"
import style0 from "./TicketPosFutbol.vue?vue&type=style&index=0&id=5378ab36&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5378ab36",
  null
  
)

export default component.exports